export enum FeatureKey {
  User = 'user',
  Farm = 'farm',
  Pond = 'pond',
  Cycle = 'cycle',
  Dashboard = 'dashboard',
  Food = 'food',
  Growth = 'growth',
  Death = 'dead_shrimp',
  WaterQuality = 'water_quality',
  WaterMineral = 'water_mineral',
  WaterVibrio = 'water_vibrio',
  Medicine = 'medicine',
  Cost = 'cost',
  Sales = 'sales',
  PdfSummary = 'pdf_summary',
  PdfDaily = 'pdf_daily',
  PdfFeatures = 'pdf_features',
  PondComparison = 'pond_comparison',
  Inventory = 'inventory',
  Credit = 'credit',
  OrganizationDashboard = 'organization_dashboard',
  Iot = 'iot',
  ShrimpTransfer = 'partial_transfer',
  ShrimpTopup = 'shrimp_topup',
}

export enum CRUDAction {
  Create = 0,
  Read = 1,
  Update = 2,
  Delete = 3,
}

// DOF-1278: IoT is independently grantable - it must not auto-enable, or
// force-keep enabled, Farm/Pond/Cycle read access the way every other
// feature does.
export const FREE_MODULES = [
  FeatureKey.Farm,
  FeatureKey.Pond,
  FeatureKey.Cycle,
  FeatureKey.User,
  FeatureKey.Iot,
]
export const TAB_MODULES = [
  FeatureKey.Dashboard,
  FeatureKey.Food,
  FeatureKey.Growth,
  FeatureKey.WaterQuality,
  FeatureKey.WaterMineral,
  FeatureKey.WaterVibrio,
  FeatureKey.Death,
  FeatureKey.Medicine,
  FeatureKey.Cost,
  FeatureKey.Sales,
  FeatureKey.Cycle,
  FeatureKey.ShrimpTransfer,
  FeatureKey.ShrimpTopup,
]
